import React from "react";

const DeviceListRowDevice = ({ device }) => {
  let statusClass = "";
  if (device.status === "Alert") statusClass = "alarm";

  return (
    <div className="device-status-list-double-column">
      <h6 className={statusClass}>{device.deviceId}</h6>
      <span className="device-status-list-summary-text">{device.name}</span>
      <span className="device-status-list-summary-text">
        {device.customerCode}
      </span>
      <span className="device-status-list-summary-text">{device.location}</span>
    </div>
  );
};

export default DeviceListRowDevice;
